import React from 'react';
import Message from '../Message';

class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError() {
		return { hasError: true };
	}

	componentDidCatch(error, errorInfo) {
		// logErrorToMyService(error, errorInfo);
		console.log(error, errorInfo);
	}

	render() {
		if (this.state.hasError) {
			return <Message status='danger'>Something went wrong.</Message>;
		}

		return this.props.children;
	}
}

export { ErrorBoundary };
